import { dynamicLoader } from '~/utils';

export const SideNavInnerToolbar = dynamicLoader({
  name: 'SideNavInnerToolbar',
  importFunc: () => import('./side-nav-inner-toolbar'),
});